import request from '@/utils/request2'

// 列表(主数据列表)
export function loadMarketReportLevelGroupListDataApi(data) {
  return request({
    url: 'tms-web/marketReportLevelGroup/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportMarketReportLevelGroupListDataApi(data) {
  return request({
    url: 'tms-web/marketReportLevelGroup/exportByPage',
    method: 'post',
    data
  })
}

// 保存
export function saveMarketReportLevelGroupApi(data) {
  return request({
    url: 'tms-web/marketReportLevelGroup/save',
    method: 'post',
    data
  })
}

// 作废
export function deleteMarketReportLevelGroupApi(data) {
  return request({
    url: 'tms-web/marketReportLevelGroup/delete',
    method: 'post',
    data
  })
}

// 查看
export function viewMarketReportLevelGroupApi(data) {
  return request({
    url: 'tms-web/marketReportLevelGroup/view',
    method: 'post',
    data
  })
}
